import { render, staticRenderFns } from "./ToLink.vue?vue&type=template&id=f8c4cf1a&"
import script from "./ToLink.vue?vue&type=script&lang=js&"
export * from "./ToLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports